import React, { useEffect, useRef } from 'react';
import {
  RichText,
  Field,
  SitecoreContext,
  withSitecoreContext,
  WithSitecoreContextProps,
} from '@sitecore-jss/sitecore-jss-react';
import { applyPhoneLinks } from '../../utils/helper';

type RichTextEditorProps = WithSitecoreContextProps & {
  fields: {
    RichTextField: Field<string>;
  };
  sitecoreContext: SitecoreContext & { pageEditing: boolean };
};

const RichTextEditor = ({ fields, sitecoreContext }: RichTextEditorProps): React.JSX.Element => {
  const elemRef: any = useRef<HTMLDivElement>(null);
  useEffect(() => {
    applyPhoneLinks(elemRef?.current, sitecoreContext.pageEditing);
  }, []);

  if (fields) {
    return (
      <div ref={elemRef}>
        {sitecoreContext.pageEditing && (
          <>
            <p>RichTextEditor Component Edit Mode</p>
          </>
        )}
        <div className="richtexteditor">
          <RichText field={fields.RichTextField} />
        </div>
      </div>
    );
  } else if (!fields && sitecoreContext.pageEditing) {
    return <p>Please setup the Datasource.</p>;
  }
  return <></>;
};

export default withSitecoreContext()(RichTextEditor);
